import React from 'react';

function Footer() {
    return(
        <footer role='contentinfo'>
            By: Steven Wagner 2019
        </footer>
    )
}

export default Footer;